import type { UserImageProps } from "@circle-react-uikit/UserImage";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import randomUserImageWithBorder1 from "@circle-react-shared/BuilderUI/Assets/user_1_image_placeholder.png";
import randomUserImageWithBorder2 from "@circle-react-shared/BuilderUI/Assets/user_2_image_placeholder.png";
import randomUserImageWithBorder3 from "@circle-react-shared/BuilderUI/Assets/user_3_image_placeholder.png";
import randomUserImageWithBorder4 from "@circle-react-shared/BuilderUI/Assets/user_4_image_placeholder.png";
import randomUserImageWithBorder5 from "@circle-react-shared/BuilderUI/Assets/user_5_image_placeholder.png";
import randomUserImageWithBorder6 from "@circle-react-shared/BuilderUI/Assets/user_6_image_placeholder.png";
import randomUserImageWithBorder7 from "@circle-react-shared/BuilderUI/Assets/user_7_image_placeholder.png";
import randomUserImageWithBorder8 from "@circle-react-shared/BuilderUI/Assets/user_8_image_placeholder.png";

interface UserGroupAvatarProps {
  count: number | null;
  size?: UserImageProps["size"];
}

const generateMockUsers = ({ count }: UserGroupAvatarProps) => {
  const userCount = count || 1;
  const randomImages = [
    randomUserImageWithBorder1,
    randomUserImageWithBorder2,
    randomUserImageWithBorder3,
    randomUserImageWithBorder4,
    randomUserImageWithBorder5,
    randomUserImageWithBorder6,
    randomUserImageWithBorder7,
    randomUserImageWithBorder8,
  ]
    // eslint-disable-next-line sonarjs/pseudo-random -- Disabled for plugin version update. Fix when possible
    .sort(() => Math.random() - 0.5)
    .slice(0, userCount);

  return randomImages.map((avatarUrl, i) => ({
    id: i + 1,
    name: `User ${i + 1}`,
    avatarUrl,
  }));
};

export const UserGroupAvatar = ({ count, size }: UserGroupAvatarProps) => {
  const mockUsers = generateMockUsers({ count });

  return (
    <div className="flex -space-x-2 rounded-full">
      {mockUsers.map((user, index) => (
        <div key={user.id} className={`rounded-full border-white z-[${index}]`}>
          <UserImageWithFallback
            src={user.avatarUrl}
            size={size}
            name={user.name}
            hasBorder
          />
        </div>
      ))}
    </div>
  );
};
